module.exports = __webpack_public_path__ + "c5af73721552566fadeb4dcbaf64bad0.svg";